import EfishDataService from '@/services/EfishDataService'
import moment from 'moment'

const DailyJournalReportService = {

  getToDateMetrics (locationId, date) {
    return EfishDataService.getData('api/v1/report/sales/toDateMetrics', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD')
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getSalesSummary (locationId, date, salesComp) {
    return EfishDataService.getData('api/v1/report/sales/salesSummary', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD'),
      type: salesComp
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getDiscountSummary (locationId, date, salesComp) {
    return EfishDataService.getData('api/v1/report/sales/discountSummary', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD'),
      type: salesComp
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getCategoriesSummary (locationId, date, salesComp) {
    return EfishDataService.getData('api/v1/report/sales/categorySummary', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD'),
      type: salesComp
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getVoidSummary (locationId, date) {
    return EfishDataService.getData('api/v1/report/sales/voidSummary', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD')
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getItemSummary (locationId, date) {
    return EfishDataService.getData('api/v1/report/sales/trackedItemSummary', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD')
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getProfitCenterSummary (locationId, date) {
    return EfishDataService.getData('api/v1/report/sales/profitCenterSummary', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD')
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getEmployeeSummary (locationId, date, salesComp) {
    return EfishDataService.getData('api/v1/report/sales/employeePromoSummary', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD'),
      type: salesComp
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getLaborSummary (locationId, date, salesComp) {
    return EfishDataService.getData('api/v1/report/sales/laborSummary', {
      location_id: locationId,
      date: moment(date).format('YYYY-MM-DD'),
      type: salesComp
    }, 'post', moment().add(30, 'Minutes').toDate())
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        return {}
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getChecks (data) {
    return EfishDataService.getData('api/v1/report/check', data, 'post', null)
      .then(x => {
        return x
      })
      .catch(error => {
        throw error
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  },
  getCheckDetails (checkId, inday) {
    return EfishDataService.getData('api/v1/report/checkdetail', {
      check_id: checkId,
      inday: inday
    }, 'post', null)
      .then(x => {
        return x
      })
      .catch(error => {
        console.log(error)
        throw error
        // throw new  Error(`[RWV] ReportService ${error}`)
      })
  }
}

export default DailyJournalReportService
